export default () => ({
  open: false,
  get menuClass() {
    return this.open ? 'show' : '';
  },
  toggle() {
    this.open = !this.open;
  },
  close() {
    this.open = false;
  },
});
